// @ts-nocheck
import { useIntl } from 'react-intl';

const WithIntl = ({ render }) => {
  const intl = useIntl();
  return render(intl);
};

export default WithIntl;
